export default "__VITE_ASSET__DIGY8YRs__"